function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#008751"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,7.5h10v15h-10V7.5Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNg);
export default __webpack_public_path__ + "static/media/NG.7f3a93341053114c26592e97674f7d19.svg";
export { ForwardRef as ReactComponent };